import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const UserEducation = () => {
  const [universityName, setUniversityName] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [qualification, setQualification] = useState("");
  const [yearOfStarting, setYearOfStarting] = useState("");
  const [yearOfPassing, setYearOfPassing] = useState("");
  const [percentage, setPercentage] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [educationOptions, setEducationOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchEducationOptions() {
      try {
        const res = await AxiosInstance.get(
          "companies/educations/"
        );
        if (res.status === 200) {
          setEducationOptions(res.data);
        } else {
          setErrorMessage(
            "Failed to fetch education options. Please try again later."
          );
        }
      } catch (err) {
        console.error(err);
        setErrorMessage(
          "Failed to fetch education options. Please try again later."
        );
      }
    }
    fetchEducationOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    const userId = localStorage.getItem("userId");
    if (!userId) {
      setErrorMessage("User ID is missing. Please log in.");
      setIsLoading(false);
      return;
    }

    const education = educationOptions.find(
      (opt) => opt.qualification === qualification
    );
    if (!education) {
      setErrorMessage("Please select a valid qualification.");
      setIsLoading(false);
      return;
    }

    const newEducation = {
      user: userId,
      education: education.education_id,
      specialization,
      college_name: collegeName,
      university: universityName,
      year_of_starting: yearOfStarting,
      year_of_passing: yearOfPassing,
      percentage_or_cgpa: parseFloat(percentage),
    };

    try {
      const res = await AxiosInstance.post(
        "companies/user/educations/",
        newEducation
      );

      if (res.status === 201) {
        alert("Education added successfully!");
        navigate(-1);
      } else {
        setErrorMessage("Something went wrong, please try again.");
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to add education. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Education</h5>
            </div>

            <div
              className="modal-body"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="universityName" className="form-label">
                    University Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="universityName"
                    className="form-control"
                    value={universityName}
                    onChange={(e) => setUniversityName(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="collegeName" className="form-label">
                    College Name
                  </label>
                  <input
                    type="text"
                    id="collegeName"
                    className="form-control"
                    value={collegeName}
                    onChange={(e) => setCollegeName(e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label htmlFor="qualification" className="form-label">
                      Qualification <span className="text-danger">*</span>
                    </label>
                    <select
                      id="qualification"
                      className="form-select"
                      value={qualification}
                      onChange={(e) => setQualification(e.target.value)}
                      required
                      disabled={isLoading}
                    >
                      <option value="">Select Qualification</option>
                      {educationOptions.length > 0 ? (
                        educationOptions.map((edu) => (
                          <option
                            key={edu.education_id}
                            value={edu.qualification}
                          >
                            {edu.qualification}
                          </option>
                        ))
                      ) : (
                        <option disabled>No education options available</option>
                      )}
                    </select>
                  </div>

                  <div className="col">
                    <label htmlFor="specialization" className="form-label">
                      Specialization <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="specialization"
                      className="form-control"
                      value={specialization}
                      onChange={(e) => setSpecialization(e.target.value)}
                      disabled={isLoading}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label htmlFor="yearOfStarting" className="form-label">
                      Year of Starting <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="yearOfStarting"
                      className="form-control"
                      value={yearOfStarting}
                      onChange={(e) => setYearOfStarting(e.target.value)}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="col">
                    <label htmlFor="yearOfPassing" className="form-label">
                      Year of Passing <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="yearOfPassing"
                      className="form-control"
                      value={yearOfPassing}
                      onChange={(e) => setYearOfPassing(e.target.value)}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="percentage" className="form-label">
                    Percentage/CGPA <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="percentage"
                    className="form-control"
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value)}
                    disabled={isLoading}
                    required
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save Education"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserEducation;
